"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shuffle = exports.shuffled = exports._shuffled = exports._shuffle = exports.normal = exports.randn = exports._normal_buffer = exports.exponential = exports.uniform = exports.random = void 0;
//@ts-check
var _globals_1 = require("./_globals");
var dtypes_1 = require("../dtypes");
function random(shape) {
    return _globals_1.nd_modules.basic.new_from(shape, function (_) { return Math.random(); }, Float64Array);
}
exports.random = random;
;
function uniform(a, b, shape) {
    return random(shape).multiply(b - a).add(a);
}
exports.uniform = uniform;
;
function exponential(mean, shape) {
    return _globals_1.np.multiply(mean, _globals_1.np.subtract(0, _globals_1.np.log(random(shape))));
}
exports.exponential = exponential;
;
function _normal_buffer(n) {
    var out = (0, dtypes_1.new_buffer)(n);
    var i = 0;
    while (i < n) {
        var u = Math.random() * 2 - 1;
        var v = Math.random() * 2 - 1;
        var s = u * u + v * v;
        if (s > 1)
            continue;
        var x = Math.sqrt(-2 * Math.log(s) / s) * u;
        var y = Math.sqrt(-2 * Math.log(s) / s) * v;
        out[i++] = x;
        if (i < n)
            out[i++] = y;
    }
    return out;
}
exports._normal_buffer = _normal_buffer;
function randn(shape) {
    var flat = _normal_buffer(shape.reduce(function (a, b) { return a * b; }, 1));
    return new _globals_1.np.NDArray(flat, shape);
}
exports.randn = randn;
;
function normal(mean, std, shape) {
    return randn(shape).multiply(std).add(mean);
}
exports.normal = normal;
;
/** @param {any[]} list */
function _shuffle(list) {
    var _a;
    // Fisher-Yates (aka Knuth) shuffle.
    // https://stackoverflow.com/a/2450976
    for (var i = list.length - 1; i >= 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        _a = __read([list[j], list[i]], 2), list[i] = _a[0], list[j] = _a[1];
    }
}
exports._shuffle = _shuffle;
function _shuffled(list) {
    var out = list.slice();
    _shuffle(out);
    return out;
}
exports._shuffled = _shuffled;
function shuffled(arr) {
    if (arr.shape.length == 0)
        return arr;
    if (arr.shape.length == 1) {
        var flat = _shuffled(arr.flat);
        return new _globals_1.np.NDArray(flat, arr.shape);
    }
    var perm = _shuffled(Array.from({ length: arr.length }, function (_, i) { return i; }));
    var out = _globals_1.np.empty(arr.shape);
    for (var i = 0; i < arr.length; i++)
        out.assign(arr.index(perm[i]), i);
    return out;
}
exports.shuffled = shuffled;
function shuffle(arr) {
    arr.assign(shuffled(arr));
}
exports.shuffle = shuffle;
